import React, { useState } from 'react';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
    website_url: '' // honeypot
  });

  const [status, setStatus] = useState(null); // 'submitting' | 'success' | 'error'

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({
          name: '',
          phone: '',
          email: '',
          message: '',
          website_url: ''
        });
      } else {
        setStatus('error');
      }
    } catch (err) {
      console.error('Submit error:', err);
      setStatus('error');
    }
  };

  return (
    <div className="bg-white p-6 sm:p-8 rounded shadow-xs border border-gray-200 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Skriv til os her</h2>

      {status === 'success' && (
        <div className="mb-6 p-4 bg-green-50 border-l-4 border-green-500 text-green-800 text-sm font-medium flex justify-between items-center">
          <span>Tak for din besked. Den er sendt.</span>
          <button onClick={() => setStatus(null)} className="text-green-600 hover:text-green-900 font-bold ml-4">×</button>
        </div>
      )}

      {status === 'error' && (
        <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-800 text-sm font-medium flex justify-between items-center">
          <span>Der opstod en fejl under forsøget på at sende din besked. Prøv igen senere.</span>
          <button onClick={() => setStatus(null)} className="text-red-600 hover:text-red-900 font-bold ml-4">×</button>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Honeypot field - mandatory sr-only absolute hidden */}
        <div className="sr-only absolute pointer-events-none opacity-0 h-0 w-0 overflow-hidden" aria-hidden="true">
          <label htmlFor="website_url">Honeypot</label>
          <input
            type="text"
            id="website_url"
            name="website_url"
            tabIndex={-1}
            autoComplete="off"
            value={formData.website_url}
            onChange={handleChange}
          />
        </div>

        <div>
          <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-1">
            Navn <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="name"
            name="name"
            required
            value={formData.name}
            onChange={handleChange}
            className="w-full px-4 py-2.5 border border-gray-300 rounded focus:ring-2 focus:ring-black focus:border-black outline-hidden transition-colors"
            placeholder="Dit navn"
          />
        </div>

        <div>
          <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-1">
            Telefonnummer <span className="text-red-500">*</span>
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            required
            value={formData.phone}
            onChange={handleChange}
            className="w-full px-4 py-2.5 border border-gray-300 rounded focus:ring-2 focus:ring-black focus:border-black outline-hidden transition-colors"
            placeholder="Dit telefonnummer"
          />
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-1">
            Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            required
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-2.5 border border-gray-300 rounded focus:ring-2 focus:ring-black focus:border-black outline-hidden transition-colors"
            placeholder="Din e-mailadresse"
          />
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-1">
            Beskrivelse <span className="text-red-500">*</span>
          </label>
          <textarea
            id="message"
            name="message"
            rows={5}
            required
            value={formData.message}
            onChange={handleChange}
            className="w-full px-4 py-2.5 border border-gray-300 rounded focus:ring-2 focus:ring-black focus:border-black outline-hidden transition-colors"
            placeholder="Skriv din besked eller forespørgsel her..."
          ></textarea>
        </div>

        <button
          type="submit"
          disabled={status === 'submitting'}
          className="w-full sm:w-auto px-8 py-3 bg-gray-900 hover:bg-black text-white font-bold rounded uppercase tracking-wider transition-colors disabled:opacity-50 cursor-pointer"
        >
          {status === 'submitting' ? 'Sender...' : 'Send besked'}
        </button>
      </form>
    </div>
  );
}
